module.exports = __webpack_public_path__ + "media/images/banner1-0b50153630721a2efb0d381bdcadb4e7.jpg";